import { render, staticRenderFns } from "./GameGridContent.vue?vue&type=template&id=1b8695d2&scoped=true&"
import script from "./GameGridContent.vue?vue&type=script&lang=js&"
export * from "./GameGridContent.vue?vue&type=script&lang=js&"
import style0 from "./GameGridContent.vue?vue&type=style&index=0&id=1b8695d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8695d2",
  null
  
)

export default component.exports